import {Injectable} from '@angular/core';


declare const window: any;

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  /**
   * Storage driver
   */
  storage: any;
  /**
   * LocalStorage driver
   */
  localStorage: any;
  /**
   * Session Storage driver
   */
  sessionStorage: any;
  /**
   * Storage method sessionstorage | localstorage
   */
  storageType = 'localstorage';
  /**
   * Used to mock storage when not available
   */
  items: any = {};
  storageEnabled: boolean;

  constructor() {
    if (!this.storageEnabled) {
      try {
        if (this.storageType === 'sessionstorage') {
          window.sessionStorage.setItem('test', 'test');
          window.sessionStorage.removeItem('test');
          this.storage = window.sessionStorage;
        } else {
          window.localStorage.setItem('test', 'test');
          window.localStorage.removeItem('test');
          this.storage = window.localStorage;
        }
        this.localStorage = window.localStorage;
        this.sessionStorage = window.sessionStorage;
        this.storageEnabled = true;
      } catch (e) {
        this.storage = this.storageFallback();
      }
    }
  }

  /**
   * A basic fallback to mock session or localStorage objects in browser memory
   *
   * @return: {{setItem: ((key, val) => any); getItem: ((key) => any); removeItem: ((key) =>
   * any); clear: (() => {})}}
   */
  storageFallback() {
    return {
      setItem: (key, val): void => this.items[key] = val,
      getItem: (key): void => this.items[key],
      removeItem: (key): void => {
        if (this.items[key]) {
          try {
            delete this.items[key];
          } catch (e) {
            this.items[key] = null;
          }
        }
      },
      clear: () => this.items = {}
    };
  }

  /**
   * use common function to set storage data
   * param key - key should be should be the key string
   * param val - val should be the 'stringified' JSON
   */
  public set(key, val: any, driver?): void {
    // remove the key if it already exists
    this.remove(key, driver);
    val = typeof val === 'string' ? val : JSON.stringify(val);
    // use configured storage type or passed on
    driver ? driver.setItem(key, val) : this.storage.setItem(key, val);
  }

  /**
   * use common public static to get session data
   */
  public get(key, driver?) {
    // return object string
    let returnObjStr;
    returnObjStr = driver ? driver.getItem(key) : this.storage.getItem(key);
    try {
      returnObjStr = JSON.parse(returnObjStr);
    } catch (e) {
    }
    if (returnObjStr === null) {
      returnObjStr = undefined;
    }
    return returnObjStr;
  }

  /**
   * public static to remove session data
   */
  public remove(keys: string | Array<string>, driver?): void {
    keys = typeof keys === 'string' ? [keys] : keys;
    keys.map(k => {
      try {
        driver ? driver.removeItem(k) : this.storage.removeItem(k);
      } catch (e) {
      }
    });
  }

  /**
   * public static to remove ALL session data
   */
  public clearAll(driver?): void {
    driver ? driver.clear() : this.storage.clear();
  }

}
